import { createAuthClient } from "@constrigo/auth-client";

export const getBackendUrl = () => {
  if (import.meta.env.PROD) {
    return import.meta.env.VITE_BACKEND_URL || "https://api.constrigo.fr";
  }
  return import.meta.env.VITE_BACKEND_URL || "http://localhost:3001";
};

/**
 * Rafraîchissement silencieux de session pour la console Ops.
 *
 * Pas de `cookieScope` : côté serveur, `OPS` n'est pas une `CookieAppType`
 * (cf. VALID_COOKIE_APPS dans apps/server/src/utils/cookies.ts), donc les
 * sessions staff n'ont que les cookies génériques. La console tournant sur une
 * origine tierce, le CSRF double-submit y est remplacé par une allowlist
 * d'Origin (AOP-9316) — mais `auth.refresh` est de toute façon exempté de CSRF
 * (endpoint d'amorçage).
 */
export const authClient = createAuthClient({
  trpcUrl: `${getBackendUrl()}/trpc`,
  appHeader: "OPS",
});

export function buildAuthHeaders(): Record<string, string> {
  const headers: Record<string, string> = { "x-constrigo-app": "OPS" };
  const csrf = authClient.readCsrf();
  if (csrf) headers["x-csrf-token"] = csrf;
  return headers;
}
